var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClipboardData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 11C4 10.4477 4.44772 10 5 10C5.55228 10 6 10.4477 6 11V12C6 12.5523 5.55228 13 5 13C4.44772 13 4 12.5523 4 12V11Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7C10 6.44772 10.4477 6 11 6C11.5523 6 12 6.44772 12 7V12C12 12.5523 11.5523 13 11 13C10.4477 13 10 12.5523 10 12V7Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9C7 8.44772 7.44772 8 8 8C8.55228 8 9 8.44772 9 9V12C9 12.5523 8.55228 13 8 13C7.44772 13 7 12.5523 7 12V9Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 1.5H3C1.89543 1.5 1 2.39543 1 3.5V14C1 15.1046 1.89543 16 3 16H13C14.1046 16 15 15.1046 15 14V3.5C15 2.39543 14.1046 1.5 13 1.5H12V2.5H13C13.5523 2.5 14 2.94772 14 3.5V14C14 14.5523 13.5523 15 13 15H3C2.44772 15 2 14.5523 2 14V3.5C2 2.94772 2.44772 2.5 3 2.5H4V1.5Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 1C9.77614 1 10 1.22386 10 1.5V2.5C10 2.77614 9.77614 3 9.5 3H6.5C6.22386 3 6 2.77614 6 2.5V1.5C6 1.22386 6.22386 1 6.5 1H9.5ZM6.5 0C5.67157 0 5 0.671573 5 1.5V2.5C5 3.32843 5.67157 4 6.5 4H9.5C10.3284 4 11 3.32843 11 2.5V1.5C11 0.671573 10.3284 0 9.5 0H6.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardData);
export default __webpack_public_path__ + "static/media/clipboard-data.afc590e2a402f73ed5741efccce80f68.svg";
export { ForwardRef as ReactComponent };